import script from "./AdminApp.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminApp.vue?vue&type=script&setup=true&lang=js"

import "./AdminApp.vue?vue&type=style&index=0&id=76be6e05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76be6e05"]])

export default __exports__